import React from 'react';

export default function PhoneWrapper({ children }) {
  return (
    <div className="portal-shell">
      <div className="portal-phone">{children}</div>
    </div>
  );
}
